import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const CarrCer: AnaColumn[] = [
    {
      itemType: "group", colCount: "1", data: [
        { 
          type: 'campo', dataField: "index", caption:' ', allowEditing:false, colVisible: true, disableOnUpdate: true, hideOnEdit: true,  
          class:'indexClass',colWidth:'70px',
        },
        {
          type: 'campoSpecial',
          dataField: 'cer',
          dataType: '',
          caption: 'EER',
          colWidth:'90px',
          orderGriglia: 1,
          maxLength: '8',
          colVisible: true,
         
          labelVisible: true,
          validation: [
            { type: 'required', message: 'Campo obbligatorio' }
          ],
          dynamic: {
            dataSource: 'cer',
            service: 'cer',
            autocomplete: false,
            filterStatic:"?$filter=(not endswith(id,'00'))",
            valueExpr: 'id',
            displayExpr: '', //Possibile inserire anche un array di campi da far apparire a video separati da - 
            caption: 'Lista EER',
            componentType: 'grid',
            related:['descrizione|cerDescrizione'],
            enableEditor: {
              add: false,
              remove: false,
              update: false
            },
            buttonOption: {
              text: 'Codici CER',
              icon: 'glyphicon mdi mdi-playlist-plus',
              hint: 'Sfoglia Lista codici CER',
              name: 'CodiciCERLista',
              location: 'after',
            }
          }
        },
  
        {
          type: 'campo',
          dataField: "cerDescrizione",
          caption: 'Descrizione',
          colVisible: true,
          cellTemplate: true,
          disableOnUpdate: true,
          hideOnEdit: true,
          colWidth:'300px',
  
  
        },
      ]
    },
  ]